import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Import the new landing page component
import NewLandingPage from './components/NewLandingPage';

// Simple redirect component for old routes
const RedirectToCalendly = () => {
  React.useEffect(() => {
    window.open('https://calendly.com/superhunt/45min', '_blank');
  }, []);
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-orange-500 mx-auto mb-4"></div>
        <p className="text-gray-600">Redirecting to schedule a consultation...</p>
        <p className="text-sm text-gray-500 mt-2">
          <a href="https://calendly.com/superhunt/45min" className="text-orange-600 hover:text-orange-800">
            Click here if not redirected automatically
          </a>
        </p>
      </div>
    </div>
  );
};

// Main App Component
const App = () => {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          <Route path="/" element={<NewLandingPage />} />
          
          {/* All authentication and user management routes redirect to Calendly */}
          <Route path="/login" element={<RedirectToCalendly />} />
          <Route path="/register" element={<RedirectToCalendly />} />
          <Route path="/verify-email" element={<RedirectToCalendly />} />
          <Route path="/profile" element={<RedirectToCalendly />} />
          <Route path="/dashboard" element={<RedirectToCalendly />} />
          <Route path="/admin" element={<RedirectToCalendly />} />
          <Route path="/apply" element={<RedirectToCalendly />} />
          <Route path="/browse-experts" element={<RedirectToCalendly />} />
          <Route path="/expert/:expertId" element={<RedirectToCalendly />} />
          <Route path="/request-consultation/:expertId" element={<RedirectToCalendly />} />
          <Route path="/my-requests" element={<RedirectToCalendly />} />
          
          {/* Catch all routes redirect to home */}
          <Route path="*" element={<NewLandingPage />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;